import logo from "./../imgs/logopng.png";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";

function PageMenu({ handleMenuBack, handleMenuItemClick, t }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // This effect now runs on mount AND whenever the URL changes

  const menuHeight = isCollapsed ? "h-16" : "h-24";
  const logoSize = isCollapsed ? "w-12 h-12" : "w-20 h-20";
  const logoTranslateY = "-translate-y-1/2";
  const menuItemPadding = isCollapsed ? "px-3 py-1" : "px-4 py-2";
  const menuItemFontSize = isCollapsed ? "text-sm" : "text-base";
  const menuGap = isCollapsed ? "gap-16 sm:gap-24" : "gap-20 sm:gap-32";

  useEffect(() => {
    const scrollContainer = document.querySelector(".overflow-auto");

    const checkAndSetCollapse = () => {
      if (scrollContainer) {
        const scrollTop = scrollContainer.scrollTop;
        setIsCollapsed((prev) => {
          if (prev) {
            return scrollTop > 10; 
          } else {
            return scrollTop > 50;
          }
        });
      }
    };

    const timer = setTimeout(checkAndSetCollapse, 100);

    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", checkAndSetCollapse);
    } else {
      console.warn(
        "Scrollable container not found for PageMenu scroll listener."
      );
    }

    // Cleanup function
    return () => {
      clearTimeout(timer); // Clear the timeout
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", checkAndSetCollapse);
      }
    };
  }, []); // 3. Re-run the effect on location change

  return (
    <div
      className={`sticky top-0 left-0 w-full bg-white shadow-md transition-all duration-300 ${menuHeight} flex items-center justify-center ${menuGap} z-50 ${
        isCollapsed ? "py-1 rounded-b-3xl bg-opacity-90" : "py-2 sm:py-3"
      }`}
    >
      <button
        className="md:hidden absolute right-4 top-1/2 transform -translate-y-1/2 z-10 text-gray-700 hover:text-gray-900"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle menu"
        aria-expanded={isMobileMenuOpen}
      >
        {isMobileMenuOpen ? (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        ) : (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
        )}
      </button>
      <div className={`pl-12 hidden md:flex items-center h-full`}>
        <Link
          to="/home#about"
          onClick={handleMenuItemClick}
          className={`text-gray-700 hover:text-gray-900 transition-colors duration-200 ${menuItemPadding} ${menuItemFontSize} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded`}
        >
          {t("menuAbout")}
        </Link>
        <Link
          to="/music"
          onClick={handleMenuItemClick}
          className={`text-gray-700 hover:text-gray-900 transition-colors duration-200 ${menuItemPadding} ${menuItemFontSize} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded`}
        >
          {t("menuMusic")}
        </Link>
      </div>

      <div
        className={`absolute top-1/2 left-1/2 transform -translate-x-1/4 ${logoTranslateY} transition-all duration-300 z-10`}
      >
        <img
          src={logo}
          alt="LiveTheWill Logo - Back to menu"
          className={`object-contain transition-all duration-300 ${logoSize} filter invert cursor-pointer -translate-x-4`}
          onClick={handleMenuBack}
          title="Back to menu"
        />
      </div>

      <div className={`hidden md:flex items-center h-full`}>
        <Link
          to="/gallery"
          onClick={handleMenuItemClick}
          className={`text-gray-700 hover:text-gray-900 transition-colors duration-200 ${menuItemPadding} ${menuItemFontSize} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded`}
        >
          {t("menuGallery")}
        </Link>
        <Link
          to="/shows"
          onClick={handleMenuItemClick}
          className={`text-gray-700 hover:text-gray-900 transition-colors duration-200 ${menuItemPadding} ${menuItemFontSize} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded`}
        >
          {t("menuShows")}
        </Link>
        <Link
          to="/home#contact"
          onClick={handleMenuItemClick}
          className={`text-gray-700 hover:text-gray-900 transition-colors duration-200 ${menuItemPadding} ${menuItemFontSize} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded`}
        >
          {t("menuContact")}
        </Link>
      </div>

      <div
        className={`md:hidden absolute top-full left-0 w-full bg-white shadow-lg transition-all duration-300 flex flex-col items-center py-2 ${
          isMobileMenuOpen
            ? "max-h-screen opacity-100"
            : "max-h-0 opacity-0 overflow-hidden"
        }`}
        style={{ visibility: isMobileMenuOpen ? "visible" : "hidden" }}
      >
        <Link
          to="/home"
          onClick={() => {
            handleMenuItemClick();
            setIsMobileMenuOpen(false);
          }}
          className={`block w-full text-center text-gray-700 hover:bg-gray-100 transition-colors duration-200 py-3 ${menuItemFontSize} focus:outline-none focus:bg-gray-100`}
        >
          Home
        </Link>
        <Link
          to="/home#about"
          onClick={() => {
            handleMenuItemClick();
            setIsMobileMenuOpen(false);
          }}
          className={`block w-full text-center text-gray-700 hover:bg-gray-100 transition-colors duration-200 py-3 ${menuItemFontSize} focus:outline-none focus:bg-gray-100`}
        >
          About
        </Link>
        <Link
          to="/music"
          onClick={() => {
            handleMenuItemClick();
            setIsMobileMenuOpen(false);
          }}
          className={`block w-full text-center text-gray-700 hover:bg-gray-100 transition-colors duration-200 py-3 ${menuItemFontSize} focus:outline-none focus:bg-gray-100`}
        >
          Music
        </Link>
        <Link
          to="/gallery"
          onClick={() => {
            handleMenuItemClick();
            setIsMobileMenuOpen(false);
          }}
          className={`block w-full text-center text-gray-700 hover:bg-gray-100 transition-colors duration-200 py-3 ${menuItemFontSize} focus:outline-none focus:bg-gray-100`}
        >
          Gallery
        </Link>
        <Link
          to="/shows"
          onClick={() => {
            handleMenuItemClick();
            setIsMobileMenuOpen(false);
          }}
          className={`block w-full text-center text-gray-700 hover:bg-gray-100 transition-colors duration-200 py-3 ${menuItemFontSize} focus:outline-none focus:bg-gray-100`}
        >
          Shows
        </Link>

        <Link
          to="/home#contact"
          onClick={() => {
            handleMenuItemClick();
            setIsMobileMenuOpen(false);
          }}
          className={`block w-full text-center text-gray-700 hover:bg-gray-100 transition-colors duration-200 py-3 ${menuItemFontSize} focus:outline-none focus:bg-gray-100`}
        >
          {t("menuContact")}
        </Link>
      </div>
    </div>
  );
}

export default PageMenu;
